export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// /Users/justin/Sites/southleft/504healthnet/wp-content/themes/healthy-hospitality/resources/assets/scripts/routes/home.js